import {
    LISTAR_TIPORECEPCIONES
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case LISTAR_TIPORECEPCIONES:
            return{
                ...state, 
                tiposRecepecion: action.payload
            }
        default:
            return state
    }
        
}